/** Receipt / slip header — default when no branch is selected */
export const RESTAURANT_RECEIPT_BRAND = {
  name: "BUTT KARAHI TIKKA",
  address: "Plaza#53, Fountain Chowk, CityHousing, Sialkot",
  contact: "03147023723",
  poweredBy: "SmartAI Soft (Pvt) Ltd",
} as const;

export const APP_LOGO_LIGHT = "/logo.png";
export const APP_LOGO_DARK = "/footerLogo.png";

export function appLogoSrc(theme: "light" | "dark"): string {
  return theme === "dark" ? APP_LOGO_DARK : APP_LOGO_LIGHT;
}

const BRANCH_DETAIL_KEY = "pos-active-branch-detail";

export type ReceiptBrand = {
  name: string;
  address: string;
  contact: string;
  poweredBy: string;
};

export function setStoredBranchDetail(branch: {
  name: string;
  address?: string | null;
  phone?: string | null;
}): void {
  const detail: ReceiptBrand = {
    name: RESTAURANT_RECEIPT_BRAND.name,
    address: RESTAURANT_RECEIPT_BRAND.address,
    contact: RESTAURANT_RECEIPT_BRAND.contact,
    poweredBy: RESTAURANT_RECEIPT_BRAND.poweredBy,
  };
  localStorage.setItem(BRANCH_DETAIL_KEY, JSON.stringify(detail));
}

export function clearStoredBranchDetail(): void {
  localStorage.removeItem(BRANCH_DETAIL_KEY);
}

/** Used by print libs (non-React) to read the active branch branding */
export function getActiveReceiptBrand(): ReceiptBrand {
  try {
    const raw = localStorage.getItem(BRANCH_DETAIL_KEY);
    if (raw) {
      const parsed = JSON.parse(raw) as ReceiptBrand;
      if (parsed.name) {
        return { ...RESTAURANT_RECEIPT_BRAND, ...parsed };
      }
    }
  } catch {
    /* use default */
  }
  return { ...RESTAURANT_RECEIPT_BRAND };
}

export function formatReceiptInvoiceNo(orderId: number): string {
  return `90${String(orderId).padStart(5, "0")}`;
}

export function formatReceiptDateTime(d: Date): string {
  if (!(d instanceof Date) || Number.isNaN(d.getTime())) {
    return "—";
  }

  // Order placedAt is naive DB wall-clock (same as Orders/Transactions lists).
  return d.toLocaleString("en-PK", {
    timeZone: "UTC",
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
}

export function formatFloorLabel(
  floorSlug: string | null | undefined,
  floorLabel?: string | null,
): string {
  if (floorLabel) return floorLabel.toUpperCase();
  if (!floorSlug) return "";
  return floorSlug.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatOrderTypeShort(orderType: string): string {
  if (orderType === "dine-in" || orderType === "reservation") return "DineIn";
  if (orderType === "take-away") return "TakeAway";
  if (orderType === "delivery") return "Delivery";
  return orderType;
}
